export default __webpack_public_path__ + "img/logo-roche.1b7a332e.svg";